import {EMI} from 'shared/model/types';

export enum Theme {
    Light = 'light',
    Dark = 'dark',
    System = 'system',
}

export const PLAN_NAME_SHORT = {
    // [EMI.Monavate]: 'ULTIMA',
    // [EMI.Walletto]: 'PRO',
    [EMI.Wallester]: 'WestStein',
};

export const GTAG_ID = 'G-9K4T3KPZMR';